import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0663bfbe")

_pushScopeId("data-v-0663bfbe")
const _hoisted_1 = { id: "aw--c" }
const _hoisted_2 = {
  id: "aw-sl",
  style: {"font-size":"1em !important"}
}
const _hoisted_3 = {
  key: 0,
  class: "wc"
}
const _hoisted_4 = {
  key: 0,
  class: "no-video-text"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("p", null, "There are no videos here! Please stay tuned.", -1)
const _hoisted_6 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_FilterComponent = _resolveComponent("FilterComponent")
  const _component_Section = _resolveComponent("Section")
  const _component_GridSkeleton = _resolveComponent("GridSkeleton")

  return (_openBlock(), _createBlock("div", { style: _ctx.themeCss }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        (_ctx.hubInfo != undefined)
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              (!_ctx.hubInfo.webinars || _ctx.hubInfo.webinars.length == 0)
                ? (_openBlock(), _createBlock("div", _hoisted_4, [
                    _hoisted_5
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_6, [
                    _createVNode(_component_FilterComponent, {
                      tags: _ctx.hubInfo.tags,
                      currentTag: _ctx.getCurrentTag(),
                      pageQueryParam: _ctx.QUERY_VARIABLE,
                      resetPage: () => {}
                    }, null, 8, ["tags", "currentTag", "pageQueryParam", "resetPage"]),
                    _createVNode(_component_Section, { webinars: _ctx.filteredVideos }, null, 8, ["webinars"])
                  ]))
            ]))
          : (_openBlock(), _createBlock(_component_GridSkeleton, {
              key: 1,
              loadingmsg: _ctx.loadingmsg
            }, null, 8, ["loadingmsg"]))
      ])
    ])
  ], 4))
})